import apiService from "../common/commonApi";

export const totalRecordDetail = {};

totalRecordDetail.list = async (param) => {    
    return apiService.Get('totalrecorddetail-list', param);
}


totalRecordDetail.delete = async (param) => {    
    return apiService.Post('totalrecorddetail-delete', param);
}
